import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
	TJotformStore,
	TGetJotformsRequest,
	TJotformListResponse,
	TGetJotformRequest,
	TJotform,
	TCreateEmerchantRequest,
	TCreateEmerchantResponse,
	TJotformListItem,
	TJotformListResponsePayload,
	TJotformWarning,
	TJotformWarningPayload,
	TCreateEmerchantResponsePayload,
} from './types';

// ==========================================:
export const initialState: TJotformStore = {
	jotforms: null,
	jotformsIsLoading: false,
	jotform: null,
	jotformIsLoading: false,
	createEmerchantIsLoading: false,
	createEmerchantWarning: null,
	createEmerchantSuccess: null,
};

// ==========================================:
const jotform = createSlice({
	name: '@@jotform',
	initialState,
	reducers: {
		getJotformsRequest: (state: TJotformStore, _action: PayloadAction<TGetJotformsRequest>) => {
			const jotformState = state;
			jotformState.jotformsIsLoading = true;
		},
		getJotformsSuccess: (
			state: TJotformStore,
			action: PayloadAction<TJotformListResponsePayload>,
		) => {
			const { payload } = action;
			const jotformState = state;
			jotformState.jotforms = payload;
			jotformState.jotformsIsLoading = false;
		},
		getJotformRequest: (state: TJotformStore, _action: PayloadAction<TGetJotformRequest>) => {
			const jotformState = state;
			jotformState.jotformIsLoading = true;
			jotformState.jotform = null;
		},
		getJotformSuccess: (state: TJotformStore, action: PayloadAction<TJotform>) => {
			const { payload } = action;
			const jotformState = state;
			jotformState.jotform = payload;
			jotformState.jotformIsLoading = false;
		},
		createEmerchantRequest: (
			state: TJotformStore,
			action: PayloadAction<TCreateEmerchantRequest>,
		) => {
			const jotformState = state;
			jotformState.createEmerchantIsLoading = true;
			jotformState.createEmerchantWarning = null;
			jotformState.createEmerchantSuccess = null;
		},
		createEmerchantSuccess: (
			state: TJotformStore,
			action: PayloadAction<TCreateEmerchantResponsePayload>,
		) => {
			const { payload } = action;
			const jotformState = state;
			jotformState.createEmerchantIsLoading = false;
			jotformState.createEmerchantWarning = null;
			jotformState.createEmerchantSuccess = payload;
		},
		createEmerchantWarning: (
			state: TJotformStore,
			action: PayloadAction<TJotformWarningPayload>,
		) => {
			const jotformState = state;
			jotformState.createEmerchantIsLoading = false;
			jotformState.createEmerchantWarning = action.payload;
			jotformState.createEmerchantSuccess = null;
		},
		createEmerchantReset: (state: TJotformStore) => {
			const jotformState = state;
			jotformState.createEmerchantIsLoading = false;
			jotformState.createEmerchantWarning = null;
			jotformState.createEmerchantSuccess = null;
		},
		jotformInitState: () => initialState,
	},
});

export default jotform.reducer;
export const {
	getJotformsRequest,
	getJotformsSuccess,
	getJotformRequest,
	getJotformSuccess,
	createEmerchantRequest,
	createEmerchantSuccess,
	createEmerchantWarning,
	createEmerchantReset,
	jotformInitState,
} = jotform.actions;
